import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RegisterContainer from '../containers/RegisterContainer';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import { routeToSignCancelRoute } from '../actions/routingActions';
import { getParams } from '../utils/other';

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.state = {
      invite_hash: null,
      invite_email: null
    };
  }

  componentDidMount() {
    this.checkEmailVerificationHash();
  }

  close() {
    this.props.routeToSignCancelRoute();
  }

  checkEmailVerificationHash() {
    const paramsString = this.props.location.search || '';
    if (
      paramsString.includes('invite_hash') &&
      paramsString.includes('invite_email')
    ) {
      const { invite_hash, invite_email } = getParams(paramsString);
      this.setState({ invite_hash, invite_email });
    }
  }

  render() {
    return (
      <HeaderContainerTemplate>
        <RegisterContainer
          inviteHash={this.state.invite_hash}
          inviteEmail={this.state.invite_email}
        />
      </HeaderContainerTemplate>
    );
  }
}

SignUp.propTypes = {
  routeToSignCancelRoute: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default connect(null, { routeToSignCancelRoute })(SignUp);



// WEBPACK FOOTER //
// ./src/scenes/SignUp.js